import React, {useState} from 'react'
import './menu.scss'
import logo from '../images/logo.png'
import joinClassNames from '../helpers/joinClassNames'
import MenuDropdown from './Layout/Menu/MenuDropdown'
import MenuItem from './Layout/Menu/MenuItem'
import MenuBurger from './Layout/Menu/MenuBurger'
import MenuProducts from './Layout/Menu/MenuProducts'
import MenuIndustries from './Layout/Menu/MenuIndustries'
import MenuKnowledge from './Layout/Menu/MenuKnowledge'
import * as routes from '../constants/routes'
import {useTranslation} from 'react-i18next'
import {Link} from 'gatsby-plugin-react-i18next'
import isPolishVersion from '../helpers/isPolishVersion'
import MenuLanguage from './Layout/Menu/MenuLanguage'
import Banner from './Layout/Banner/Banner'
import {isNull} from 'lodash'

const Menu = ({showNavigation = true, banner = null}) => {
    const {t, i18n} = useTranslation()
    const [isOpen, setIsOpen] = useState(false)

    return (
        <nav
            className={joinClassNames('navbar main-menu', showNavigation && 'has-shadow is-fixed-top')}
            role="navigation"
            aria-label="main navigation"
        >
            {!isNull(banner) && <Banner banner={banner} />}
            <div className="container" style={{margin: '0 auto', padding: 0}}>
                <div className="navbar-brand">
                    <Link className="navbar-item" to={routes.HOME}>
                        <img src={logo} alt="logo" style={{marginBottom: 0}} width={143} height={28} />
                    </Link>
                    {showNavigation && <MenuBurger isOpen={isOpen} setIsOpen={setIsOpen} />}
                </div>
                {showNavigation && (
                    <div id="thulium-menu-items" className={joinClassNames('navbar-menu', isOpen ? 'is-active' : null)}>
                        <div className="navbar-start">
                            <MenuDropdown title={t('menu_products')}>
                                <MenuProducts />
                            </MenuDropdown>
                            <MenuDropdown title={t('menu_industries')}>
                                <MenuIndustries />
                            </MenuDropdown>
                            <MenuItem title={t('menu_prices')} href={routes.PRICING} />
                            <MenuDropdown title={t('menu_knowledge-base')}>
                                <MenuKnowledge />
                            </MenuDropdown>
                            {isPolishVersion(i18n.language) && (
                                <MenuItem title={t('menu_partners')} href={routes.PARTNERS} />
                            )}
                            <MenuItem title={t('menu_contact')} href={routes.CONTACT} />
                        </div>
                        <div className="navbar-end">
                            <div className="navbar-item">
                                <div className="buttons main-menu__action-buttons">
                                    <Link to={routes.LOGIN} className={'button is-light is-rounded'}>
                                        {t('menu_login')}
                                    </Link>
                                    <Link to={routes.PRESENTATION_FORM} className={'button is-primary is-rounded'}>
                                        <strong>{t('menu_presentation')}</strong>
                                    </Link>
                                </div>
                            </div>
                            <MenuLanguage />
                        </div>
                    </div>
                )}
            </div>
        </nav>
    )
}

export default Menu
